import { useTranslation } from "react-i18next";
import type { BlobItem as BlobItemType } from "@azure/storage-blob";
import { BlobItem } from "./blob-item/BlobItem";
import { EmptyState } from "./EmptyState";
import { BlobStore } from "@/stores/BlobStore";

interface BlobListProps {
  onBlobView?: (blob: BlobItemType) => void;
}

export function BlobList({
  onBlobView
}: BlobListProps) {
  const { t } = useTranslation();

  const blobs = BlobStore((state) => state.blobs);

  if (blobs.length === 0) {
    return <EmptyState />;
  }

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <ul className="divide-y divide-gray-200">
          {blobs.map((blob, index) => (
            <BlobItem
              key={`${blob.name}-${index}`}
              blob={blob}
              index={index}
              onView={onBlobView}
            />
          ))}
        </ul>
      </div>

      <div className="mt-4 text-sm text-gray-500">
        {t("knowledgeBase.totalFiles", { count: blobs.length })}
      </div>
    </>
  );
}